import StatXHR from './stat-xhr.js';

// Default options for the plugin.
const DEFAULTS = {
	method: "POST",
	sendOnAd: false,
	intervalStartEvents: ['vast.firstPlay'],
	intervalStopEvents: ['vast.lastPostrollEnd', 'error'],
	events: ['seeked'],
	dataAddons: function() {
		return {
			uid: this.utils.getUid(),
			referer: encodeURIComponent(this.utils.isIFrame() ? this.utils.getIFrameReferer() : document.location.href)
		};
	}
	
};

/**
 * The Stat class to send stat for tracking video playback.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends StatXHR
 */

class StatWebcaster extends StatXHR {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options);
		super(player, options_);

		this.dataAddons = options_.dataAddons;
	}

	getData(ev) {
		let da = this.utils.processVal.call(this, this.dataAddons, ev),
			data = Object.assign({}, da, super.getData(ev));
		return data;
	}
}

export default StatWebcaster;
